import { useAuth } from './useAuth';
export const Actions = {
    READ: 'READ',
    WRITE: 'WRITE',
    SCHEDULE: 'SCHEDULE',
    VALIDATE: 'VALIDATE',
    VALIDATE_EXCLUDE_LINEAGES: 'VALIDATE_EXCLUDE_LINEAGES',
    ROLLBACK: 'ROLLBACK',
    DELETE: 'DELETE',
};
const VIEWER_ACTIONS = [Actions.READ];
export function usePermissions() {
    const { user, viewerMode } = useAuth();
    const effectiveActions = viewerMode ? VIEWER_ACTIONS : (user?.actions ?? []);
    const effectiveRole = viewerMode ? 'viewer' : (user?.role ?? null);
    const hasAction = (action) => effectiveActions.includes(action);
    const hasAllActions = (actions) => actions.every((action) => effectiveActions.includes(action));
    const hasAnyAction = (actions) => actions.some((action) => effectiveActions.includes(action));
    const isAdmin = () => effectiveRole === 'admin';
    const isViewer = () => effectiveRole === 'viewer';
    return {
        actions: effectiveActions,
        role: effectiveRole,
        hasAction,
        hasAllActions,
        hasAnyAction,
        isAdmin,
        isViewer,
        canRead: hasAction(Actions.READ),
        canWrite: hasAction(Actions.WRITE),
        canSchedule: hasAction(Actions.SCHEDULE),
        canValidate: hasAction(Actions.VALIDATE),
        canValidateExcludeLineages: hasAction(Actions.VALIDATE_EXCLUDE_LINEAGES),
        canRollback: hasAction(Actions.ROLLBACK),
        canDelete: hasAction(Actions.DELETE),
    };
}
